export const readerEditInfo = {
    editExcludeFields: []
}